export const model = {
    username: "username",
    password: "password",
    connection: "connexion",
}



